import React, {Component} from 'react';
import LoginScreen from "./login/LoginScreen";
import {connect} from 'react-redux';
import {autoLoginIfUserSaved} from "./login/LoginAction";
import MainScreen from "./MainScreen";
import UnauthorizedScreen from "./UnauthorizedScreen";
import {resetNavigationToOverview} from "./navigation/NavigationActions";



class Root extends Component {

    componentWillMount(){
        this.props.autoLoginIfUserSaved()
    }
    render() {
        if(this.props.isLoggedIn){
            return(<MainScreen/>)
        }else{
            return(<UnauthorizedScreen/>)
        }
    }
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.auth.isLoggedIn,
        //loadingLoginFailed: state.loadingLoginFailed,
        //isLoading: state.loginIsLoading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        autoLoginIfUserSaved: () => dispatch(autoLoginIfUserSaved())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Root);




// WEBPACK FOOTER //
// ./src/Root.js